import dayjs from 'dayjs';
const getHours = (hours, daytime) => {
    // Convert to 24-hour format
    if (daytime === 'PM') {
        // 12 PM stays as 12, 1-11 PM add 12
        return hours === 12 ? 12 : hours + 12;
    }
    // daytime === 'AM'
    // 12 AM becomes 0, 1-11 AM stay as is
    return hours === 12 ? 0 : hours;
};
export const setTimeToDate = (date, timeString) => {
    if (!timeString) {
        return date;
    }
    // NOTE: time format is HH:MM AMPM
    const [time, daytime] = timeString.split(' ');
    const [hours, minutes] = time.split(':');
    if (!time || !daytime || !hours || !minutes) {
        return date;
    }
    const parsedHours = parseInt(hours);
    return dayjs(date).set('hour', getHours(parsedHours, daytime)).minute(parseInt(minutes)).toDate();
};
